const TENANTS = {
    UK: {
        name: 'athena-uk',
        languages: ['en'],
        url: 'uk',
    },
    UAE: {
        name: 'athena-uae',
        languages: ['en', 'ar'],
        url: 'en-ae',
    },
    AT: {
        name: 'athena-at',
        languages: ['de'],
        url: 'de-at',
    },
    DE: {
        name: 'athena-de',
        languages: ['de'],
        url: 'de',
    },
    AU: {
        name: 'athena-au',
        languages: ['en'],
        url: 'au',
        tenantUrlEnabled: true,
    },
    IE: {
        name: 'athena-ie',
        languages: ['en'],
        url: 'ie',
    },
    SA: {
        name: 'athena-sa',
        languages: ['en', 'ar'],
        url: 'sa',
    },
};

module.exports = {
    widgetUrl: 'https://www.doctify.com',
    widgetV2Url: 'https://www.doctify.com/wv2',
    apiUrl: 'https://www.doctify.com/',
    dashboardUrl: 'https://dashboard.doctify.com/',
    TENANTS,
    auDefaultLinkUrl: 'https://www.doctify.com/au/about/patient-feedback-matters'
};
